import { Cross2Icon } from '@radix-ui/react-icons';
import type { JSX } from 'react';
import type { MobileFilterDrawerChip } from '@/components/dashboard/mobile/MobileFilterDrawer';

export function AvailabilitiesFilterToolbar({
  hasActiveFilters,
  activeFiltersLabel,
  titleLabel,
  subtitle,
  emptyLabel,
  resetLabel,
  openLabel,
  onOpenDrawer,
  onReset,
  summaryChips,
}: {
  hasActiveFilters: boolean;
  activeFiltersLabel: string;
  titleLabel: string;
  subtitle: string;
  emptyLabel: string;
  resetLabel: string;
  openLabel: string;
  onOpenDrawer: () => void;
  onReset: () => void;
  summaryChips: MobileFilterDrawerChip[];
}): JSX.Element {
  return (
    <div className="rounded-3xl border border-surface-subtle bg-white/80 p-4 shadow-sm backdrop-blur">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-sm font-semibold text-brand-primary">{titleLabel}</p>
          <p className="text-xs text-text-primary/60">{subtitle}</p>
          <p className="text-[0.7rem] text-text-primary/50">
            {hasActiveFilters ? activeFiltersLabel : emptyLabel}
          </p>
        </div>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={onReset}
            disabled={!hasActiveFilters}
            className="min-h-11 rounded-2xl border border-brand-primary/20 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-brand-primary transition hover:border-brand-primary/40 hover:bg-brand-primary/5 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {resetLabel}
          </button>
          <button
            type="button"
            onClick={onOpenDrawer}
            data-ui="Public.Availabilities.OpenFilters"
            className="min-h-11 rounded-2xl bg-brand-primary px-4 py-2 text-xs font-semibold uppercase tracking-wide text-white shadow-sm transition hover:bg-brand-primary/90"
          >
            {openLabel}
          </button>
        </div>
      </div>

      {summaryChips.length > 0 ? (
        <div className="mt-4">
          <div className="flex flex-wrap gap-2">
            {summaryChips.map((chip) => {
              if (typeof chip.onRemove === 'function') {
                return (
                  <button
                    key={chip.id}
                    type="button"
                    onClick={() => {
                      chip.onRemove?.();
                    }}
                    className="inline-flex min-h-11 items-center gap-2 rounded-full border border-brand-primary/30 bg-white px-4 py-2 text-xs font-semibold uppercase tracking-wide text-brand-primary shadow-sm"
                  >
                    <span>{chip.label}</span>
                    <Cross2Icon className="h-3 w-3" aria-hidden />
                  </button>
                );
              }

              return (
                <span
                  key={chip.id}
                  className="inline-flex min-h-11 items-center rounded-full border border-surface-subtle bg-white px-4 py-2 text-xs font-semibold uppercase tracking-wide text-text-primary/70"
                >
                  {chip.label}
                </span>
              );
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
}
